import React from "react";
import {formatMessage} from "devextreme/localization";
import {SingleCard} from "../../layouts";

export default ({icon, className, children}) => {

    return <SingleCard title={formatMessage('sifreSifirla.baslik')}
                       page="SifreSifirlaSonucSayfa">
        <div className="kq-form">
            <p style={{textAlign:"center"}}>
                <i className={icon}/>
            </p>

            <p className={className}>
                {children}
            </p>
        </div>
    </SingleCard>
}
